// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1VYV8","head":"Table_head___oB7i","col":"Table_col__1iAD_"};